import {ProposedService} from '../../../server/routes/availability/types';
import {ANY_EMPLOYEE} from '../../store/slices/constants';

export const generateReschedulePostOrder = ({
  date,
  time,
  proposedServices,
  isAvailableDay,
  employeeId,
  shouldShowMultiStaffSelection,
}: {
  date: string | null;
  time: string | null;
  proposedServices: ProposedService[];
  isAvailableDay: boolean;
  employeeId?: number | typeof ANY_EMPLOYEE;
  shouldShowMultiStaffSelection?: boolean;
}) => {
  if (!proposedServices.length || !date || !time || !isAvailableDay) {
    return;
  }
  return proposedServices.map((service) => {
    const offer = {
      date,
      time,
      ...service,
      employeeId: service.employeeId ? {id: service.employeeId} : undefined,
    };
    if (!shouldShowMultiStaffSelection && employeeId !== ANY_EMPLOYEE) {
      return {...offer, employeeId: {id: employeeId}};
    }
    return offer;
  });
};
